import { Text } from 'preact-i18n';

import { getFeatureIcon } from '../../../../utils/getFeatureIcon';
import { isOnOffFan, fanModesFor } from '../../../../utils/fanModes';
import BinaryDeviceFeature from './BinaryDeviceFeature';

const FanModeDeviceFeature = ({ children, ...props }) => {
  const { deviceFeature } = props;
  // A fan with no speeds is a switch, and a five-way select for it offers four ways to say "on"
  if (isOnOffFan(deviceFeature)) {
    return <BinaryDeviceFeature {...props} />;
  }

  function updateValue(e) {
    props.updateValueWithDebounce(deviceFeature, Number(e.currentTarget.value));
  }

  const modes = fanModesFor(deviceFeature);

  return (
    <tr>
      <td>
        <i class={`fe fe-${getFeatureIcon(deviceFeature, 'wind')}`} />
      </td>
      <td>{props.rowName}</td>

      <td class="py-0">
        <div class="d-flex justify-content-end">
          <div class="form-group mb-0">
            <select value={deviceFeature.last_value} onChange={updateValue} class="form-control form-control-sm">
              {modes.map(mode => (
                <option key={mode} value={mode}>
                  <Text id={`deviceFeatureValue.category.fan.mode.${mode}`} />
                </option>
              ))}
            </select>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default FanModeDeviceFeature;
